module.exports = __webpack_public_path__ + "static/media/90.c7b11e6c.png";